/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { OasExternalDocumentation } from '../../models/OasExternalDocumentation';

/**
 * @author eric.wittmann@gmail.com
 * @class
 * @extends OasExternalDocumentation
 */
export class Oas30ExternalDocumentation extends OasExternalDocumentation {
    constructor() {
        super();
    }
}
Oas30ExternalDocumentation["__class"] = "io.apicurio.datamodels.openapi.v3.models.Oas30ExternalDocumentation";
Oas30ExternalDocumentation["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




